import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getFunctionToPassByLanguage from '../../services/functionToPass/getFunctionToPassByLanguage'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchFunctionToPassSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchFunctionToPassCombo () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const combo = yield call(getFunctionToPassByLanguage, auth.token)
    yield put(fetchFunctionToPassSuccess(combo))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchFunctionToPass () {
  yield takeLatest(combosActionTypes.FETCH_FUNCTION_TO_PASS, fetchFunctionToPassCombo)
}
